import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function courseTypeWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRefinementList,
    showCounters: showCounters,
    facetCounterAttribute: "course_type"
  }).widget({
    container: 'course_type',
    attribute: 'course_type',
    operator: "or",
    templates: { item: loadTemplate(showCounters ? "cle_course_type_filter_template_with_counters" : "cle_course_type_filter_template") },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["name:asc"]
  })
}

export function courseTypeMobileWidget() {
  return new SelectRefinementWidget({ selectType: "multiple" }).widget({
    attribute: "course_type",
    container: "course_type_mobile",
    sortBy: ["name:asc"]
  })
}
